import { createApp } from 'vue'
import i18n from './i18n'
import { createVuestic } from 'vuestic-ui'
import { createGtm } from '@gtm-support/vue-gtm'
import ApexCharts from 'apexcharts'
import VueApexCharts from 'vue3-apexcharts'

// TypeScript declaration for global ApexCharts
declare global {
  interface Window {
    ApexCharts: typeof ApexCharts
  }
}

import './styles/theme.css' // Theme styles
import './styles/notifications.css' // Notification styles

import stores from './stores'
import router from './router'
import vuesticGlobalConfig from './services/vuestic-ui/global-config'
import App from './App.vue'

// Global error handler to catch Vue internals errors
const app = createApp(App)

// Make ApexCharts available globally
window.ApexCharts = ApexCharts

// Register VueApexCharts component globally
app.component('Apexchart', VueApexCharts)

app.config.errorHandler = (err, instance, info) => {
  // Log the error for debugging
  console.warn('Vue Error Handler:', {
    error: err,
    component: instance?.$options?.name || 'Unknown',
    info: info,
  })

  // Prevent the error from breaking the app
  // Only re-throw critical errors that should break the app
  if (err instanceof Error && err.message.includes('parentNode')) {
    console.warn('Suppressing parentNode error - likely a transition issue')
    return
  }

  // For other errors, you might want to re-throw them
  // throw err
}

app.use(stores)
app.use(router)
app.use(i18n)
app.use(createVuestic({ config: vuesticGlobalConfig }))

if (import.meta.env.VITE_APP_GTM_ENABLED) {
  app.use(
    createGtm({
      id: import.meta.env.VITE_APP_GTM_KEY,
      debug: false,
      vueRouter: router,
    }),
  )
}

app.mount('#app')
